import { render, staticRenderFns } from "./DepartManagerView.vue?vue&type=template&id=3620b1a9&scoped=true"
import script from "./DepartManagerView.vue?vue&type=script&lang=js"
export * from "./DepartManagerView.vue?vue&type=script&lang=js"
import style0 from "./DepartManagerView.vue?vue&type=style&index=0&id=3620b1a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3620b1a9",
  null
  
)

export default component.exports